export var getNextSlidesCount = function(param) {
    var cols = param.cols, slideIndex = param.slideIndex, slideCount = param.slideCount;
    return Math.max(0, slideCount - (slideIndex + (cols || 0)));
};
export var getPreviousSlidesCount = function(param) {
    var slideIndex = param.slideIndex;
    return slideIndex;
};
